import { render } from "./infoBasica.vue?vue&type=template&id=13913380&scoped=true"
import script from "./infoBasica.vue?vue&type=script&lang=js"
export * from "./infoBasica.vue?vue&type=script&lang=js"

import "./infoBasica.vue?vue&type=style&index=0&id=13913380&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13913380"]])

export default __exports__